import { render, staticRenderFns } from "./AddPrincipalDialog.vue?vue&type=template&id=0ca647cf&scoped=true"
import script from "./AddPrincipalDialog.vue?vue&type=script&lang=js"
export * from "./AddPrincipalDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPrincipalDialog.vue?vue&type=style&index=0&id=0ca647cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca647cf",
  null
  
)

export default component.exports